import assembleTranslationLanguages from './assembleTranslationLanguages'

export default assembleTranslationLanguages
